// extracted by mini-css-extract-plugin
module.exports = {"link":"svg_link___jzUp"};